export const DashboardLogoutP = "Your session has been expired"
export const DashboardLogoutP1 = "Please click"
// export const DashboardLogoutP2 = "https://coop-visit-staging-dashboard.azurewebsites.net/DashboardLogin"
export const DashboardLogoutP21 = "https://coop-cleaners-dashboard.azurewebsites.net/DashboardLogin"
export const DashboardLogoutP3 = "to login again"
export const DashboardLogoutP4 = "For any support please contact Coop Admin team."
// export const DashboardLogoutP5 = "visit@coop.co.uk"